import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const NORRKOPING = [58.5942, 16.1826];

function pinIcon(emoji, color) {
  return L.divIcon({
    className: "",
    html: `<div style="display:grid;place-items:center;height:40px;width:40px;border-radius:50% 50% 50% 0;background:${color};transform:rotate(-45deg);box-shadow:0 4px 10px rgba(0,0,0,.3)"><span style="transform:rotate(45deg);font-size:18px">${emoji}</span></div>`,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
  });
}

export const MapTracker = ({ dropoff, courier }) => {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const dropRef = useRef(null);
  const courierRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !ref.current) return;
    const map = L.map(ref.current, { zoomControl: true, attributionControl: false }).setView(NORRKOPING, 13);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(map);
    mapRef.current = map;
    setTimeout(() => map.invalidateSize(), 200);
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    const pts = [];
    if (dropoff) {
      const ll = [dropoff.lat, dropoff.lng];
      if (dropRef.current) dropRef.current.setLatLng(ll);
      else dropRef.current = L.marker(ll, { icon: pinIcon("🏠", "#0D9488") }).addTo(map);
      pts.push(ll);
    }
    if (courier) {
      const ll = [courier.lat, courier.lng];
      if (courierRef.current) courierRef.current.setLatLng(ll);
      else courierRef.current = L.marker(ll, { icon: pinIcon("🛵", "#E11D48") }).addTo(map);
      pts.push(ll);
    }
    if (pts.length === 2) map.fitBounds(pts, { padding: [60, 60], maxZoom: 15 });
    else if (pts.length === 1) map.setView(pts[0], 14);
  }, [dropoff, courier]);

  return <div ref={ref} className="ha-map" data-testid="tracking-map" />;
};

export default MapTracker;
